import { render, staticRenderFns } from "./cropper.vue?vue&type=template&id=1131fbde&scoped=true&"
import script from "./cropper.vue?vue&type=script&lang=js&"
export * from "./cropper.vue?vue&type=script&lang=js&"
import style0 from "./cropper.vue?vue&type=style&index=0&id=1131fbde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1131fbde",
  null
  
)

export default component.exports